import { subscribe } from "pubsub-js";

import type { Callback, EventMessage } from "./types.ts";

export const subscribeEvent = <TCallback extends Callback<any>>(event: EventMessage, callback: TCallback) => {
  // simplify api to not need message parameter
  const withMessageCallback: Parameters<typeof subscribe>[1] = (_message, data) => {
    callback(data);
  };

  return subscribe(event, withMessageCallback);
};
